import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/MessagePopup.module.css';

const CannonClashPopup = ({ isOpen, message, onClose, showCloseButton = true }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <p className={styles.popupMessage}>{message}</p>
        {showCloseButton && (
          <button
            className={styles.closeButton}
            onClick={onClose}
          >
            {t('popups.close')}
          </button>
        )}
      </div>
    </div>
  );
};

export default CannonClashPopup;